import { useEffect } from 'react';
import { userManager } from '@src/auth/oidcConfig';

/**
 * Target of the silent-renew iframe (`silent_redirect_uri`).
 *
 * signinSilent() prefers the refresh token, so this only runs on the iframe
 * fallback. It renders nothing on purpose: the user never sees this route, it
 * exists so oidc-client-ts can hand the authorization response back to the
 * UserManager in the parent frame.
 */
export function SilentCallbackView() {
  useEffect(() => {
    userManager.signinSilentCallback().catch((error: unknown) => {
      // Nothing to recover here. The parent frame's signinSilent() rejects on
      // its own timeout and the caller decides what to do.
      console.warn('OIDC: silent callback failed', error);
    });
  }, []);

  return null;
}
